import { DateTime } from 'luxon'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faSortAlt } from '@fortawesome/pro-light-svg-icons'

import { Grid, Text } from '@domain-group/suit-theme'
import { digObject } from '@domain-group/javascript-utils'

import type { TaskListModel } from '@models/types'

import { calculateCompletionDecimal, useRelations } from '@hooks/useTaskList'

import Item from './Item'

interface OverviewProps {
  callbacks: {
    createOrEditTaskList: () => void,
  },
  taskList: TaskListModel,
}

const Overview = (props: OverviewProps) => {
  const {
    callbacks: { createOrEditTaskList },
    taskList,
  } = props

  const { brand } = useRelations(taskList)

  const dueDateString = digObject(taskList, 'dates.due.date')

  const remainingTasksDecimal = calculateCompletionDecimal(taskList, { showRemaining: true })
  const remainingTasksPercentage = (remainingTasksDecimal * 100).toFixed()

  return (
    <Grid
      gridAutoRows="1fr"
      gridTemplateColumns="repeat(3, minmax(152px, 1fr))"
      gridTemplateRows="repeat(1, minmax(76px, 1fr))"
    >
      <Item callbacks={{ createOrEditTaskList }} icon={<FontAwesomeIcon icon={faCalendarAlt} />} label="Due Date">
        <Text fontSize="small">
          {dueDateString ? DateTime.fromFormat(dueDateString, 'dd/MM/yyyy').toFormat('ccc dd LLL yyyy') : 'Not Set'}
        </Text>
      </Item>

      <Item
        icon={<FontAwesomeIcon icon={faSortAlt} />}
        label="Remaining Tasks"
      >
        <Text fontSize="small">
          {taskList.task_counts?.incomplete} ({remainingTasksPercentage}%)
        </Text>
      </Item>

      <Item callbacks={{ createOrEditTaskList }} icon={<FontAwesomeIcon icon={faSortAlt} />} label="Owner">
        <Text fontSize="small">{brand.title || 'No Brand'}</Text>
      </Item>
    </Grid>
  )
}

export default Overview
